import * as React from "react"
import * as Primitives from "@radix-ui/react-checkbox"
import { clx, MinusMiniIcon, CheckMiniIcon } from "~/design-system"

/**
 * This component is based on the [Radix UI Checkbox](https://www.radix-ui.com/primitives/docs/components/checkbox) primitive.
 */
const Checkbox = React.forwardRef<
  React.ElementRef<typeof Primitives.Root>,
  React.ComponentPropsWithoutRef<typeof Primitives.Root>
>(({ className, checked, ...props }, ref) => {
  return (
    <Primitives.Root
      {...props}
      ref={ref}
      checked={checked}
      className={clx(
        "group relative inline-flex h-5 w-5 items-center justify-center outline-none ",
        className
      )}
    >
      <div className={clx(
        "text-white bg-ui-bg-base border border-ui-border-strong shadow-borders-with-shadow group-hover:bg-ui-bg-base-hover group-focus-visible:!shadow-buttons-focus h-[18px] w-[18px] rounded-[5px]",
        "group-data-[state=checked]:bg-blue-base group-data-[state=checked]:border-blue-base group-data-[state=indeterminate]:bg-blue-base group-data-[state=indeterminate]:border-blue-base",
        "group-disabled:!text-ui-fg-faint group-disabled:!bg-ui-bg-disabled group-disabled:!shadow-borders-base group-disabled:!border-ui-border-strong"
      )}>
        <Primitives.Indicator className="absolute inset-0">
          {checked === "indeterminate" ? <MinusMiniIcon size={20} /> : <CheckMiniIcon />}
        </Primitives.Indicator>
      </div>
    </Primitives.Root>
  )
})
Checkbox.displayName = "Checkbox"

export { Checkbox }
